import React from 'react';
import CusButton from '../../../../components/material-ui/CusButton';
import { IconUserPlus } from '@tabler/icons-react';

export default function AddNewUserBtn({ onClick }) {
  return (
    <CusButton
      startIcon={<IconUserPlus />}
      text="Add user"
      variant="outlined"
      onClick={onClick}
      sx={{ my: 0.5, py: 0.5 }}
    />
  );
}
